import { replace, toUpper, isEmpty, prop, uniq } from 'ramda';
import { get } from 'lodash';

import { BookingArtist } from "../../models/booking-artist.model";
import { travelsOrEmpty, contactRelationsOrEmpty } from '../../models/travel.model';
import { getPromoterDefaultDetails } from "../../models/local-details.model";


import { contactIdPromoterView, usersView, userView } from '../../models/booking-overview.model';
import { createArtist } from '../../models/artist.model';
import { getFilterColor } from '../../models/status-colors';
import { checkTabListPermission } from '../../../../router/guard';
import { dateFromMonth, getYearMonthHFromObj, getYearMonthH } from '../../../../utility/calendar';
import { createTV } from '../../../../models/text-value.model';


export const bookingsGetters = {


  selectedMonths: (state) => state.selectedMonths,

  bookingList: (state) => state.bookingList,
  // bookingListHeaders: (state) => state.bookingListHeaders,

  //! No more required
  // bookingDetailsFlag: (state) => state.bookingDetailsFlag,
  //! No more required
  artistDetailsFlag: (state) => state.artistDetailsFlag,

  // !No more required
  // bookingModuleActive: (state) => {
  //   console.log([
  //     state.bookingDetailsFlag, 
  //     state.artistDetailsFlag
  //   ]);
  //   return ![
  //     state.bookingDetailsFlag, 
  //     state.artistDetailsFlag
  //   ].some(e => e);
  // },


  artists: (state) => {
    return state.artists.map(e => createArtist({
      ...e,
      text: e['artist_name'],
      value: e['artist_id'],
    }))
  },
  artistsTV: (state) => {
    return createTV(state?.artists, 'artist_name', 'artist_id');
  },

  staffs: (state) => {
    return state.users.map(e => ({
      text: e['user_name'],
      value: e['user_id'],
    }))
  },

  statuses: (state) => {
    return state.statuses;
  },
  statusesTV: (state) => {
    return state.statuses.map(e => ({
      text: e.booking_status_name,
      value: e.booking_status_id
    }));
  },

  statusColorMap: (state) => {
    return state?.statuses?.reduce((accm, cur) => {
      accm[cur.booking_status_name] = `#${cur.booking_status_colour}`;
      return accm;
    }, {}) || {};
  },

  // TODO: Change from Contract Months to Months
  monthsTV: (state) => {
    let month = state.months.map(e => ({
      text: replace(/^./, toUpper, e.month) + ' ' + e.year,
      value: e.month_val
    }));
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const currDate = new Date()
    const currentDateString = monthNames[currDate.getMonth()] + " " + currDate.getFullYear()
    const index = month.findIndex(x => x.text === currentDateString);
    month.splice(index + 1, 0, { text: "*Future Dates*", value: "future_dates" });
    // console.log("MONTH", month[index]);

    return month;

    // let month = ;
    // const monthNames = ["January", "February", "March", "April", "May", "June",
    //   "July", "August", "September", "October", "November", "December"
    // ];
    // const currDate = new Date()
    // const currentDateString = monthNames[currDate.getMonth()] + " " + currDate.getFullYear()
    // const index = month.findIndex(x => x.text === currentDateString);
    // month.splice(index + 1, 0, { text: "*Future Dates*", value: "future_dates" });
    // console.log("GETTER MONTHS", month[index]);

    // return month

    // return [...state.months.map(e => ({
    //   text: replace(/^./, toUpper, e.month) + ' ' + e.year,
    //   value: e.month_val
    // })),{ text: "*Future Dates*", value: "future_dates" }]
  },

  calendarMonthsTV: (state) => {
    console.log('state.months', state.months.map(e => {
      return {
        text: replace(/^./, toUpper, e.month) + ' ' + e.year,
        value: getYearMonthHFromObj(e)
      }
    }))
    return state.months.map(e => {
      return {
        text: replace(/^./, toUpper, e.month) + ' ' + e.year,
        value: getYearMonthHFromObj(e)
      }
    });
  },

  filter: (state) => state.filter,

  paginationFilter: (state) => state.paginationFilter,
  listFilter: (state) => {
    const filter = state.filter;

    let status = `[${filter.selectedStatuses ? filter.selectedStatuses.map(e => e.value).join(",") : ''}]`;
    let artist = filter?.selectedArtist?.value || '*';
    let staff_id = filter?.selectedStaff?.value || '';

    let booking_month = filter?.selectedMonths?.value || '';
    let txt = filter?.txt.value || ''
    let sort = filter?.sort ? JSON.stringify(filter.sort) : '';

    return {
      booking_month,
      status,
      artist,
      staff_id,
      txt,
      status_c: getFilterColor(filter, 'status_c'),
      status_r: getFilterColor(filter, 'status_r'),
      status_l: getFilterColor(filter, 'status_l'),
      status_t: getFilterColor(filter, 'status_t'),
      status_i: getFilterColor(filter, 'status_i'),
      status_exclusivity: getFilterColor(filter, 'status_exclusivity'),
      sort
    }
  },


  // External Calendars
  externalDates: (state) => state.externalDates,

  bookingLocationsSet: (state) => {
    return BookingArtist.getUniqueLocations(state.bookingArtistList);
  },
  bookingCitySet: (state) => {
    return BookingArtist.getUniqueCities(state.bookingArtistList);
  },
  selectedBooking: (state) => state.selectedBooking,
  selectedBookingCalendarDateId: (state) => state.selectedBooking.calendar_date_id,
  calendarDateId: (state) => state.selectedBooking.calendar_date_id,
  calendarDate: (state) => state.selectedBooking.start_date,

  selectedBookingCancellationToken: (state) => state.selectedBookingCancellationToken,

  bookingArtistList: (state) => state.bookingArtistList,
  bookingArtistListLoading: (state) => state.bookingArtistListLoading,
  filteredBookingArtistList: (state, getters, rootState, rootGetters) => {
    // console.log(state.filter.selectedArtist)
    // const artistIds = state.filter.selectedArtist ? state.filter.selectedArtist.map(e => e.value) : [];
    // const userNames = state.filter.selectedStaff ? state.filter.selectedStaff.map(e => e.text) : [];

    // Removing the Bookings that contains Artists that are hidden in "Hide Fees for the Following" in Settings>User

    const blockedBookings = uniq((rootGetters.account?.user_permissions?.blocked?.booking_artists || [])?.map(blockedArtist => {
      return state.bookingArtistList?.filter(e => e?.artist_id == blockedArtist)?.map(e => e?.calendar_date_id);
    }).flat());
    
    return state.bookingArtistList?.filter(e => {
      if (blockedBookings?.includes(e?.calendar_date_id)) {
        return false;
      } else {
        return true;
      }
    });
    // .filter(bookingArtist =>
    //   (
    //     (isEmpty(artistIds) || artistIds.includes(bookingArtist.artist_id)) &&
    //     (isEmpty(userNames) || userNames.includes(bookingArtist.user_name))
    //   )
    // )
  },

  bookingSidewindowTabs: (state) => {
    return checkTabListPermission('booking', 'calendar', state.bookingSidewindowTabs);
  },
  bookingSideWindowSelectedTab: (state) => state.bookingSideWindowSelectedTab,

  // SelectedBookingTasks
  selectedBookingTasks: (state) => state.selectedBookingTasks,

  // Overview Getters
  // overview_gridLayout: (state) => {
  //   state.overview_gridLayout.layout.map(e => {
  //     e.gridItemClass = getGridItemClass(e);
  //   });
  //   return state.overview_gridLayout;
  // },
  bookingOverview: (state) => state.bookingOverview,
  contactIdPromoter: (state) => {
    return contactIdPromoterView(state.bookingOverview);
  },
  selectedBookingPromoter: (state) => {
    return state.bookingOverview.promoter;
  },

  currencies: (state) => {
    return state.bookingOverview.currencies;
  },

  defaultCurrency: (state) => {
    return state.bookingOverview.currencies.find(cur => {
      if (cur.currency_id == state.bookingOverview.cdate.currency_id) {
        return true;
      } else {
        return false;
      }
    })
  },

  users: usersView,
  usersTV: state => {
    return usersView(state).map(e => ({
      text: e.user_name,
      value: e.user_id
    }));
  },
  user: userView,

  currenciesTextValue: (state) => {
    return state.bookingOverview.currencies.map(e => ({
      text: e['currency_iso'],
      value: e['currency_id'],
      ...e
    }));
  },
  getCurrencyById: (state, getters) => {
    return (currency_id) => {
      return getters.currenciesTextValue.find(c => {
        if (c.value === currency_id) {
          return true;
        } else {
          return false;
        }
      }) || {
        ...getters.currenciesTextValue.find(c => {
          if (c.currency_iso === 'EUR') {
            return true;
          } else {
            return false;
          }
        })
      };
    }
  },
  bookingOverviewArtists: (state) => {
    return BookingArtist.fromPKtoList(state.bookingArtistList, state.bookingOverviewArtists);
  },

  checklist: (state) => {
    const bookingOverview = state.bookingOverview;

    return state.checklist.map(e => {
      return {
        ...e,
        children: e.children.map(f => {
          const value = get(bookingOverview, f.xpath) == `1`;
          // console.log(bookingOverview, f.xpath, value);
          return {
            ...f,
            value
          };
        })
      };
    });
  },
  customChecklist: (state) => state.custom_checklist,
  notes: (state) => {
    const notes = state.notes;
    return {
      ...notes,
      value: get(state.bookingOverview, notes.xpath)
    };
  },
  offerNotes: (state) => {
    const offerNotes = state.offer_notes;
    return {
      ...offerNotes,
      value: get(state.bookingOverview, offerNotes.xpath)
    };
  },
  moneyDetailsGridLayout: (state) => {
    return state.moneyDetailsGridLayout;
  },
  // moneyDetailsInvoicesListHeaders: (state) => {
  //   return state.moneyDetailsInvoicesListHeaders;
  // },
  // selectedInvoiceLines: (state) => {
  //   return state.selectedInvoiceLines;
  // },
  confirmedInvoices: (state) => {
    return state.bookingOverview.invoices;
  },
  invoiceLines: (state) => {
    return state.invoiceLines;
  },
  invoiceLinesData: (state) => {
    return state.invoiceLines.data.map(e => ({
      ...e,
      isEditable: !e['color']
    }));
  },

  taxTypes: (state) => state.taxTypes,
  // Tax Types Text Value
  taxTypesTV: (state) => state.taxTypes.map(t => ({
    'value': t['tax_type_id'],
    'text': t['tax_name'],
    ...t
  })),


  // Send Document Files Getters

  sendDocumentFilesData: (state) => state.sendDocumentFilesData,


  itemGroups: state => state.itemGroups,

  loggedUserTasks: (state) => state.loggedUserTasks,
  bookingRequests: (state) => {
    // console.log(state.bookingRequests);
    return state.bookingRequests;
  },
  bookingRequestSelectedItem: (state) => state.bookingRequestSelectedItem,
  bookingTemplates: (state) => state.bookingTemplates,

  // EVENT DETAILS GETTERS
  eventDetailsGridLayout: (state) =>
    state.eventDetailsGridLayout,
  eventDetails: (state) =>
    state.eventDetails,
  // artists: (state) => {
  //   return BookingArtist.fromPKtoList(state.bookingArtistList, state.bookingOverviewArtists);
  // },
  eventDetailsFields: (state) => {
    return state.eventDetails.data.fields
  },
  // eventDetailsArtistsHeaders: (state) => 
  //   state.eventDetailsArtistsHeaders,
  lineup: (state) =>
    state.eventDetails.data.cdate.lineup,
  ticketPrice: (state) =>
    state.eventDetails.data.cdate.ticket_price,
  doorsOpen: (state) =>
    state.eventDetails.data.cdate.doors_open,
  curfew: (state) =>
    state.eventDetails.data.cdate.curfew,
  eventUrl: (state) =>
    state.eventDetails.data.cdate.event_url,


  // TRAVEL_DETAILS GETTERS
  travelDetailsState: (state) => state.travelDetailsState,
  // travelListHeaders: (state) => state.travelListHeaders,
  travelBeforeData: (state) => {
    return travelsOrEmpty(state).filter(e => prop('after_gig_flag', e) !== "1");
  },
  travelAfterData: (state) => {
    return travelsOrEmpty(state).filter(e => prop('after_gig_flag', e) === "1");
  },
  travelsData: (state) => travelsOrEmpty(state),
  contactRelations: (state) => {
    return contactRelationsOrEmpty(state);
  },

  // LOCAL_DETAILS GETTERS
  calendarDateLocals: (state) => {
    return state.calendar_date_locals;
  },
  localInfo: (state) => {
    return state.localInfo;
  },
  localDetailsConfirmedFlag: (state) => {
    return state.localDetails.cdate.local_details_confirmed_flag;
  },
  promoterDefault: (state) => state.promoterDefault,
  promoterDefaultDetails: (state) => {
    return getPromoterDefaultDetails(state.promoterDefault);
  },
  relationTypes: (state) => state.relationTypes,

  // DOCUMENTS_GETTERS
  documentsGridLayout: (state) => state.documentsGridLayout,
  documentTableHeaders: (state) => state.documentTableHeaders,
  documents: (state) => state.documents,
  documentsData: (state) => state.documentsData,
  files: (state) => state.files,
  templates: (state) => state.templates,
  documentChecklist: (state) => {
    const documentsData = state.documentsData.data;

    return state.documentChecklist.map(e => {
      return {
        ...e,
        children: e.children.map(f => {
          const value = get(documentsData, f.xpath) === `1` ? true : false;
          // console.log(documentsData,  f.xpath);
          return {
            ...f,
            value
          }
        })
      }
    })
  },


  bookingDetails: (state) => state.bookingDetails || {},

  //CALENDAR_BOOKING_LIST Filter Getters

  statusesTT: (state) => {
    return state.statuses.map(e => ({
      text: e.booking_status_name,
      value: e.booking_status_name
    }));
  },
  calendarFilter: state => {
    return {
      selectedMonth: state.calendarFilter.selectedMonth || getYearMonthH(new Date()),
      selectedStatuses: state.calendarFilter.selectedStatuses || [],
      selectedArtists: state.calendarFilter.selectedArtists || [],
      selectedStaffs: state.calendarFilter.selectedStaffs || [],
      showExternalCalendar: state.calendarFilter.showExternalCalendar || false,
    }
  },

  calendarBookingList: state => state.calendarBookingList,
  filteredCalendarBookingList: (state, getters, rootState, rootGetters) => {
    const blockedArtists = (rootGetters.account?.user_permissions?.blocked?.booking_artists || []);

    const filter = state.calendarFilter;
    const artistIds = (filter.selectedArtists ? filter.selectedArtists : [])
      // .filter(e => (rootGetters.account?.user_permissions?.blocked?.booking_artists || []).includes(e))
      .map(e => +e);
    const userIDs = (filter.selectedStaffs ? filter.selectedStaffs : []).map(e => +e);
    const selectedStatuses = filter.selectedStatuses ? filter.selectedStatuses : [];

    const bookingMonths = state.calendarBookingList?.months?.map(month => {
      const bookingArtistList = [
        ...(month?.list?.events || []),
        ...(month?.list?.bookings || []),
      ].map(BookingArtist.create);
      // console.log({ "bookingArtistList": bookingArtistList, userIDs, artistIds, selectedStatuses });

      const blockedBookings = uniq(blockedArtists?.map(a => bookingArtistList?.find(ba => ba?.artist_id == a)?.calendar_date_id));
      // console.log({ 'getters.js:475 blockedBookings': blockedBookings });

      const list = bookingArtistList
        .filter(bookingArtist =>
          filterBookingArtistList(bookingArtist, artistIds, userIDs, selectedStatuses, blockedBookings))
        .map(BookingArtist.create);
      // console.log({ "list": list });
      const external_dates = (month.external_dates || [])
        .filter(externalDate =>
          filterBookingArtistList(externalDate, artistIds, userIDs, selectedStatuses, blockedBookings));

      return {
        ...month,
        external_dates,
        list,
      }
    });
    return {
      ...state.calendarBookingList,
      months: bookingMonths,
    };
  },

};
function filterBookingArtistList(bookingArtist, artistIds, userIDs, selectedStatuses, blockedBookings) {
  return !blockedBookings.includes(bookingArtist?.calendar_date_id) &&
    (artistIds.includes(+bookingArtist?.artist_id)) &&
    (isEmpty(userIDs) || userIDs.includes(bookingArtist?.user_id)) &&
    (isEmpty(selectedStatuses) || selectedStatuses.includes(bookingArtist?.booking_status_name));
}

